import { dataEnglishComment } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEnglishComment = /*#__PURE__*/createIcon(dataEnglishComment)
export default IconEnglishComment
